import manager from 'app/module46/component-manager.js';

/**
 *
 * @param {HTMLInputElement} element
 * @param {HTMLElement[]} references
 * @param attributes
 * @param properties
 */
const accordionBlocComponent = (element, references, attributes, properties) => {
	const parent = element.parentElement;

	const clickEventListener = (e) => {
		if (element.checked === true) {
			parent.style.flexGrow = '1';
		} else {
			parent.style.removeProperty('flex-grow');
		}
	};

	element.addEventListener('click', clickEventListener);
};

console.log('registering accordion-bloc');
manager.register('accordion-bloc', accordionBlocComponent);
